export enum OverlayStyleEnum {
  FullScreen = 0,
  Letterbox = 1,
  Custom = 2,
}

export type OverlayStyle =
  | OverlayStyleEnum.FullScreen
  | OverlayStyleEnum.Letterbox
  | OverlayStyleEnum.Custom;
